<app-navigation-header title="Properties" i18n-title="@@propertyMaintab-Properties">
	<app-property-list-table [appBreadcrumbLabel]="propertyListBreadcrumbLabel"></app-property-list-table>
</app-navigation-header>
